import React, { useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Row, Col, Container, Collapse } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { conversationAddressAct } from 'redux_new/actions'

import ModalAddress from './ModalAddress'
import AddressView from './AddressView'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

const ConversationAddress = ({ userId, isRemoveByUser }) => {
  const conversationAddress = useSelector((store) => store.conversationAddress[userId] || store.conversationAddress.initial)
  const dispatch = useDispatch()

  const { address, isOpen, isLoading } = conversationAddress
  const [showModal, setShowModal] = useState(false)

  // Collapse dropdown
  const onClickCollapse = useCallback(
    () => {
      dispatch(isOpen ? conversationAddressAct.close() : conversationAddressAct.get())
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOpen]
  )

  const toggle = () => {
    if (!isRemoveByUser) onClickCollapse()
  }

  // Show modal and edit address
  const onEdit = useCallback(() => setShowModal(!showModal), [showModal])

  return (
    <div className={`plugin-address-card ${isRemoveByUser ? 'disabled' : ''}`}>
      <div className='title-container'>
        <div className='title'>
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-user-dark.svg')} alt='Address' />
          </figure>
          <p>{I18n.t('dashboard_contact-information')}</p>
        </div>
        <div className='action-buttons-container'>
          <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`} onClick={toggle} />
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <Container className='mt-3 content-container'>
          {isLoading ? <Nixi1Spinner height='23px' width='23px'/> : <AddressView address={address} onClick={onEdit} />}
          {!address && !isLoading ? (
            <Row className='mt-3'>
              <Col className='text-right'>
                <Button size='sm' color='primary' onClick={onEdit}>
                  {I18n.t('dashboard_add-address')}
                </Button>
              </Col>
            </Row>
          ) : null}
          {isOpen && !isLoading && showModal ? <ModalAddress userId={userId} currentAddress={address} showModal={showModal} onCloseModal={onEdit} /> : null}
        </Container>
      </Collapse>
    </div>
  )
}

export default React.memo(ConversationAddress)
